module.exports = __webpack_public_path__ + "static/media/noun_help_1715151.03a49e5a.png";